import BuysEstimateListContainer from '../../containers/buys_estimate/BuysEstimateListContainer';

const BuysEstimateListPage = () => {
  return <BuysEstimateListContainer />;
};

export default BuysEstimateListPage;
